import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const ProtectedRoute = ({ children, isAllowed }) => {
  const { isAuthenticated, loading, userRole } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <div>Loading...</div>;

  // 🟡 Case 2: Not logged in, go to home/login
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // 🟢 Case 1: Public route (isAllowed === undefined) and user IS logged in → redirect to dashboard
  if (isAllowed === undefined) {
    switch (userRole?.name) {
      case 'admin':
        return <Navigate to="/admin/dashboard" replace />;
      case 'recruiter':
      case 'accountOwner':
        return <Navigate to="/recruiter/dashboard" replace />;
      case 'jobseeker':
        return <Navigate to="/jobseeker/dashboard" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }

  // 🔴 Case 3: Logged in but not allowed (wrong role)
  if (isAllowed === false) {
    return <Navigate to="/access-denied" replace />;
  }

  // ✅ Case 1, valid role + route → allow access
  return children;
};

export default ProtectedRoute;
